// External Library or Components
import React from "react";
import { Card } from "react-bootstrap";
import history from "../app/history";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Helmet } from "react-helmet";
import {
  CartApi,
  CatalogueDetailApi,
  resetCatalogueDetail,
} from "../redux/actions/apiActions/apiAction";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { Table } from "reactstrap";
import Loader from "../components/Spinner";
import No_Image from "../assets/images/no_image.jpg";
import config from "../config";
class SlugCatalogueProductDetail extends React.Component {
  state = {
    loader: false,
    isOpen: false,
    lightBoxSource: "",
    quantity: 0,
    productId: "",
    loading: false,
    loadingTable: false,
  };

  componentDidMount = async () => {
    this.setState({ loading: true });

    const {
      match: { params },
    } = this.props;
    if (params.slug) {
      let res = await this.props.CatalogueDetailApi(params.slug, "slug");
      if (res && res.status !== 200) {
        history.push("/");
      }
    } else {
      history.goBack();
    }
    this.setState({ loading: false });
  };

  componentDidUpdate = async (prevProps, prevState) => {
    const {
      match: { params },
    } = this.props;
    if (params.slug && params.slug !== prevProps.match.params.slug) {
      this.setState({ slug: params.slug, loading: true });
      let res = await this.props.CatalogueDetailApi(params.slug, "slug");
      if (res && res.status !== 200) {
        history.push("/");
      }
      window.scroll(0, 0);
      this.setState({ loading: false });
    }
  };

  componentWillUnmount = () => {
    this.props.resetCatalogueDetail();
  };

  handleAddToCart = async (data) => {
    if (!this.state.quantity && this.state.quantity <= 0) {
      toastr.error("Quantity should be > 0");
      return;
    }
    this.setState({ loader: true, loading: true });
    setTimeout(() => {
      let cart = JSON.parse(localStorage.getItem("HandyCart"));
      if (cart && cart.length > 0) {
        let findExisting = cart.filter((one) => {
          return one.product.partnerItemCode === data.partnerItemCode;
        });
        if (findExisting && findExisting.length > 0) {
          let removeExisting = cart.filter((one) => {
            return one.product.partnerItemCode !== data.partnerItemCode;
          });
          let dataToAdd = {
            product: data,
            qty: parseInt(this.state.quantity) + findExisting[0].qty,
          };
          removeExisting.push(dataToAdd);
          localStorage.setItem("HandyCart", JSON.stringify(removeExisting));
        } else {
          let dataToAdd = {
            product: data,
            qty: parseInt(this.state.quantity),
          };
          cart.push(dataToAdd);
          localStorage.setItem("HandyCart", JSON.stringify(cart));
        }
      } else {
        let store = [];
        let dataToAdd = {
          product: data,
          qty: parseInt(this.state.quantity),
        };
        store.push(dataToAdd);
        localStorage.setItem("HandyCart", JSON.stringify(store));
      }
      this.setState({ loadingTable: true });
      this.props.CartApi();
      toastr.success("Successfully Added To Cart");
      this.setState({ loader: false, loading: false, quantity: 0 });
      this.setState({ loadingTable: false });
    }, 800);
  };

  handleAddToCartAll = async () => {
    this.setState({ loader: true, loading: true });
    setTimeout(() => {
      let data = this.props.productData;
      for (let i = 0; i < data.relatedItems.length; i++) {
        if (document.getElementById(data.relatedItems[i].id).value > 0) {
          let cart = JSON.parse(localStorage.getItem("HandyCart"));
          if (cart && cart.length > 0) {
            let findExisting = cart.filter((one) => {
              return (
                one.product.partnerItemCode ===
                data.relatedItems[i].partnerItemCode
              );
            });
            if (findExisting && findExisting.length > 0) {
              let removeExisting = cart.filter((one) => {
                return (
                  one.product.partnerItemCode !==
                  data.relatedItems[i].partnerItemCode
                );
              });
              let dataToAdd = {
                product: data.relatedItems[i],
                qty:
                  parseInt(
                    document.getElementById(data.relatedItems[i].id).value
                  ) + findExisting[0].qty,
              };
              removeExisting.push(dataToAdd);
              localStorage.setItem("HandyCart", JSON.stringify(removeExisting));
            } else {
              let dataToAdd = {
                product: data.relatedItems[i],
                qty: parseInt(
                  document.getElementById(data.relatedItems[i].id).value
                ),
              };
              cart.push(dataToAdd);
              // console.log(dataToAdd);
              localStorage.setItem("HandyCart", JSON.stringify(cart));
            }
          } else {
            let store = [];
            let dataToAdd = {
              product: data.relatedItems[i],
              qty: parseInt(
                document.getElementById(data.relatedItems[i].id).value
              ),
            };
            store.push(dataToAdd);
            // console.log(dataToAdd);
            localStorage.setItem("HandyCart", JSON.stringify(store));
          }
        }
      }
      this.setState({ loadingTable: true });
      this.props.CartApi();
      toastr.success("Successfully Added To Cart");
      this.setState({ loader: false, loading: false, quantity: 0 });
      this.setState({ loadingTable: false });
    }, 800);
  };
  navigateToDetailView = async (one) => {
    if (one.slug && !one.slug.includes("%")) {
      history.push({
        pathname: `/${one.slug}`,
        state: one,
      });
    } else {
      history.push({
        pathname: "/view",
        state: one,
      });
    }
  };
  render() {
    let data = this.props.productData;
    const endpoint = config.BASE_FILE_URL;
    return (
      <div className="catalogue-section" style={{ marginTop: "70px" }}>
        {this.state.loading ? (
          <Loader />
        ) : this.props &&
          this.props.history.location &&
          this.props.history.location.state ? (
          <Helmet>
            <title>
              {" "}
              {this.props.history.location.state
                ? this.props.history.location.pathname.split("/")[1]
                : ""}
            </title>{" "}
            <meta
              name="description"
              content={
                this.props.history.location.state.seoDescription
                  ? this.props.history.location.state.seoDescription
                  : ""
              }
            />{" "}
            <meta
              name="keywords"
              content={
                this.props.history.location.state.seoKeyword
                  ? this.props.history.location.state.seoKeyword
                  : ""
              }
            />
          </Helmet>
        ) : (
          <></>
        )}

        <div className="cust-container">
          <div className="with-sidebar">
            <button
              className="product-ctlg-close"
              onClick={() => history.goBack()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="12"
                viewBox="0 0 13 12"
              >
                <defs>
                  <clipPath id="z1i4a">
                    <path
                      fill="#fff"
                      d="M6.147 13.646a1 1 0 0 1-1-1v-13a1 1 0 0 1 2 0v13a1 1 0 0 1-1 1z"
                    />
                  </clipPath>
                  <clipPath id="z1i4b">
                    <path
                      fill="#fff"
                      d="M6.854 13.646a1 1 0 0 1-1-1v-13a1 1 0 0 1 2 0v13a1 1 0 0 1-1 1z"
                    />
                  </clipPath>
                </defs>
                <g>
                  <g transform="rotate(45 6 6)">
                    <path
                      fill="#fff"
                      d="M6.147 13.646a1 1 0 0 1-1-1v-13a1 1 0 0 1 2 0v13a1 1 0 0 1-1 1z"
                    />
                    <path
                      fill="none"
                      stroke="#fff"
                      stroke-miterlimit="20"
                      stroke-width="2"
                      d="M6.147 13.646a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1v0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1z"
                      clip-path='url("#z1i4a")'
                    />
                  </g>
                  <g transform="rotate(135 7 6)">
                    <path
                      fill="#fff"
                      d="M6.854 13.646a1 1 0 0 1-1-1v-13a1 1 0 0 1 2 0v13a1 1 0 0 1-1 1z"
                    />
                    <path
                      fill="none"
                      stroke="#fff"
                      stroke-miterlimit="20"
                      stroke-width="2"
                      d="M6.854 13.646a1 1 0 0 1-1-1v-13a1 1 0 0 1 1-1v0a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1z"
                      clip-path='url("#z1i4b")'
                    />
                  </g>
                </g>
              </svg>
              <span>Close</span>
            </button>
            <div className="sidebar-content ctlg-sidebar-content">
              <div className="product-details-view">
                {data && (
                  <>
                    <div className="product-image-wrapper">
                      <div
                        className="product-image"
                        style={{
                          backgroundImage: `url(${
                            !this.state.loading
                              ? endpoint + "ProductImages?file=" + data.image ||
                                No_Image
                              : ""
                          })`,
                        }}
                        onClick={() => {
                          this.setState({
                            isOpen: true,
                            lightBoxSource:
                              endpoint + "ProductImages?file=" + data.image,
                          });
                        }}
                      ></div>
                    </div>
                    <div className="product-details">
                      <div className="col-lg-10 px-0">
                        <h3 className="productname ctlg-product-title">
                          {data.displayDescription
                            ? data.displayDescription
                            : data.description}
                        </h3>
                        {/* <p className="ctlg-product-info">
                          {data.displayDescription}
                        </p> */}
                        <div className="row product-summary-details mt-5">
                          <div className="col col-sm-5">
                            <div className="detail-wrapper">
                              <h5>Category</h5>
                              {data.category &&
                                data.category.map((one) => {
                                  return <p className="mt-1">{one.name}</p>;
                                })}
                              {data.category && data.category.length <= 0 && (
                                <p className="mt-1">
                                  {"No category available"}
                                </p>
                              )}
                            </div>
                          </div>

                          {/* <div className="col col-sm-7">
                                                    <div className="detail-wrapper">
                                                        <h5>Sub-Category</h5>
                                                        <p>Adults ±145g Super Cotton T-Shirts (501)</p>
                                                    </div>
                                                </div> */}
                        </div>
                      </div>
                      <div className="product-description mt-3">
                        {/* //Table */}

                        {!this.state.loadingTable && (
                          <div className="custom-scrollbar">
                            <Table className="app-grid with-border news-grid ctlg-product-table">
                              <thead>
                                <tr>
                                  <th className="Title-col">Code</th>
                                  <th className="Content-col">Name</th>
                                  <th className="ctlg-stock-col">Stock</th>
                                  <th className="ctlg-qty-col">Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.relatedItems &&
                                  data.relatedItems.map((one, index) => {
                                    let qty = 0;
                                    one.itemPricing.map((each) => {
                                      if (each.partnerStoreCode === "JHB") {
                                        qty = each.partnerQtyOnHand;
                                        console.log(qty, "qty");
                                      }
                                    });
                                    return (
                                      <tr>
                                        <th scope="row">
                                          {one.partnerItemCode}
                                        </th>
                                        <td>{one.description}</td>
                                        <td>
                                          {qty > 0
                                            ? qty > 10
                                              ? "In Stock"
                                              : "Low Stock"
                                            : "Out of Stock"}
                                        </td>
                                        <td className="">
                                          <div className="element-group ctlg-qty-input-group">
                                            <input
                                              id={one.id}
                                              type="number"
                                              defaultValue={this.state.quantity}
                                              min={0}
                                              onChange={(e) =>
                                                this.setState({
                                                  quantity: e.target.value,
                                                })
                                              }
                                            />
                                            {/* <button
                                          addonType="append"
                                          className="action-button "
                                          onClick={() =>
                                            this.handleAddToCart(one)
                                          }
                                        >
                                          <i className="icon-add"></i>
                                        </button> */}
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                {/* <tr>
                                <th scope="row">502B1</th>
                                <td>KIDS BLK T-SHIRT COT±145g S</td>
                                <td>In stock</td>
                                <td className="">
                                  <div className="element-group ctlg-qty-input-group">
                                    <input
                                      id={data.id}
                                      type="number"
                                      defaultValue={this.state.quantity}
                                      min={1}
                                      onChange={(e) =>
                                        this.setState({
                                          quantity: e.target.value,
                                        })
                                      }
                                    />
                                    <button
                                      addonType="append"
                                      className="action-button "
                                      // onClick={() =>
                                      //   this.handleAddToCart(one)
                                      // }
                                    >
                                      <i className="icon-add"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th scope="row">502B1</th>
                                <td>KIDS BLK T-SHIRT COT±145g S</td>
                                <td>In stock</td>
                                <td className="">
                                  <div className="element-group ctlg-qty-input-group">
                                    <input
                                      id={data.id}
                                      type="number"
                                      defaultValue={this.state.quantity}
                                      min={1}
                                      onChange={(e) =>
                                        this.setState({
                                          quantity: e.target.value,
                                        })
                                      }
                                    />
                                    <button
                                      addonType="append"
                                      className="action-button "
                                      // onClick={() =>
                                      //   this.handleAddToCart(one)
                                      // }
                                    >
                                      <i className="icon-add"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th scope="row">502B1</th>
                                <td>KIDS BLK T-SHIRT COT±145g S</td>
                                <td>In stock</td>
                                <td className="">
                                  <div className="element-group ctlg-qty-input-group">
                                    <input
                                      id={data.id}
                                      type="number"
                                      defaultValue={this.state.quantity}
                                      min={1}
                                      onChange={(e) =>
                                        this.setState({
                                          quantity: e.target.value,
                                        })
                                      }
                                    />
                                    <button
                                      addonType="append"
                                      className="action-button "
                                      // onClick={() =>
                                      //   this.handleAddToCart(one)
                                      // }
                                    >
                                      <i className="icon-add"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr> */}
                              </tbody>
                            </Table>
                          </div>
                        )}
                        {data.relatedItems && data.relatedItems.length > 0 && (
                          <div className="d-flex justify-content-center">
                            <button
                              addonType="append"
                              className="btn common-button "
                              onClick={() => this.handleAddToCartAll()}
                            >
                              {" "}
                              {"Add to Quote"}
                              {/* <i className="icon-add"></i> */}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {this.state.isOpen && (
                  <Lightbox
                    mainSrc={this.state.lightBoxSource}
                    onCloseRequest={() => this.setState({ isOpen: false })}
                  />
                )}
              </div>
            </div>
          </div>
          {data.similarProducts && data.similarProducts.length > 0 && (
            <>
              <h3 class="productname ctlg-product-title text-center font-weight-bold">
                Other related products
              </h3>
              <div className="row">
                {!this.state.loadingTable &&
                  data.similarProducts &&
                  data.similarProducts.map((one) => {
                    return (
                      <div className="col-lg-3 col-md-6 mt-4">
                        <Card className="catalogue-card">
                          <div
                            className="product-image"
                            onClick={() => {
                              //  this.setState({isOpen : true, lightBoxSource : one.image})
                              this.navigateToDetailView(one);
                            }}
                            style={{
                              backgroundImage: `url(${
                                endpoint + "ProductImages?file=" + one.image ||
                                No_Image
                              })`,
                            }}
                          ></div>

                          <Card.Body>
                            <div className="header-text text-center">
                              <Card.Title
                                onClick={() => this.navigateToDetailView(one)}
                              >
                                {one.description}
                              </Card.Title>
                            </div>
                            {/* <div className="card-row mt-3">
                        <div className="left-box mr-2">
                          <Card.Title>Code</Card.Title>
                          <Card.Text>
                            <span>{one.partnerItemCode}</span>
                          </Card.Text>
                        </div>
                        <div className="left-box mr-2">
                          <Card.Title>Promo</Card.Title>
                          <Card.Text>
                            <span>{one.onPromo ? 'On promo' : "Not on promo"}</span>
                          </Card.Text>
                        </div>
                      </div>
                      <div className="card-row mt-3">
                      <div className="right-box">
                        <Card.Title>Category</Card.Title>
                        {one.category.map(one =>{
                            return <Card.Text>
                            <span>{one.name}</span>
                          </Card.Text>
                        })}
                        
                      </div>
                        <div className="element-group ctlg-qty-input-group align-items-end">
                          <input
                            id={one.id}
                            type="number"
                            defaultValue={this.state.quantity}
                            min={1}
                            onChange={(e) =>
                              this.setState({
                                quantity: e.target.value,
                              })
                            }
                          />
                          <button
                            addonType="append"
                            className="action-button "
                            onClick={() =>
                              this.handleAddToCart(one)
                            }
                          >
                            <i className="icon-add"></i>
                          </button>
                        </div>
                      </div> */}
                          </Card.Body>
                        </Card>
                      </div>
                    );
                  })}
                {/* <div className="col-lg-3 col-md-6 mt-4">
              <Card className="catalogue-card">
                <div
                  className="product-image"
                  // onClick={() => {
                  //  setIsOpen(true);
                  //  setLightBoxImage(one.image || "");
                  // }}
                  style={{
                    backgroundImage: `url(${demoProductImg})`,
                  }}
                ></div>

                <Card.Body>
                  <div className="header-text">
                    <Card.Title>
                      Adults ±145g Super Cotton T-Shirt - Royal
                    </Card.Title>
                  </div>
                  <div className="right-box">
                    <Card.Title>Category</Card.Title>
                    <Card.Text>
                      <span>T-Shirts</span>
                    </Card.Text>
                  </div>
                  <div className="card-row mt-3">
                    <div className="right-box mr-2">
                      <Card.Title>Sub-Category</Card.Title>
                      <Card.Text>
                        <span>Adults ±145g Super Cotton T-Shirts (501)</span>
                      </Card.Text>
                    </div>
                    <div className="element-group ctlg-qty-input-group">
                      <input
                        id={data.id}
                        type="number"
                        defaultValue={this.state.quantity}
                        min={1}
                        onChange={(e) =>
                          this.setState({
                            quantity: e.target.value,
                          })
                        }
                      />
                      <button
                        addonType="append"
                        className="action-button "
                        // onClick={() =>
                        //   this.handleAddToCart(one)
                        // }
                      >
                        <i className="icon-add"></i>
                      </button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className="col-lg-3 col-md-6 mt-4">
              <Card className="catalogue-card">
                <div
                  className="product-image"
                  // onClick={() => {
                  //  setIsOpen(true);
                  //  setLightBoxImage(one.image || "");
                  // }}
                  style={{
                    backgroundImage: `url(${demoProductImg})`,
                  }}
                ></div>

                <Card.Body>
                  <div className="header-text">
                    <Card.Title>
                      Adults ±145g Super Cotton T-Shirt - Royal
                    </Card.Title>
                  </div>
                  <div className="right-box">
                    <Card.Title>Category</Card.Title>
                    <Card.Text>
                      <span>T-Shirts</span>
                    </Card.Text>
                  </div>
                  <div className="card-row mt-3">
                    <div className="right-box mr-2">
                      <Card.Title>Sub-Category</Card.Title>
                      <Card.Text>
                        <span>Adults ±145g Super Cotton T-Shirts (501)</span>
                      </Card.Text>
                    </div>
                    <div className="element-group ctlg-qty-input-group">
                      <input
                        id={data.id}
                        type="number"
                        defaultValue={this.state.quantity}
                        min={1}
                        onChange={(e) =>
                          this.setState({
                            quantity: e.target.value,
                          })
                        }
                      />
                      <button
                        addonType="append"
                        className="action-button "
                        // onClick={() =>
                        //   this.handleAddToCart(one)
                        // }
                      >
                        <i className="icon-add"></i>
                      </button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className="col-lg-3 col-md-6 mt-4">
              <Card className="catalogue-card">
                <div
                  className="product-image"
                  // onClick={() => {
                  //  setIsOpen(true);
                  //  setLightBoxImage(one.image || "");
                  // }}
                  style={{
                    backgroundImage: `url(${demoProductImg})`,
                  }}
                ></div>

                <Card.Body>
                  <div className="header-text">
                    <Card.Title>
                      Adults ±145g Super Cotton T-Shirt - Royal
                    </Card.Title>
                  </div>
                  <div className="right-box">
                    <Card.Title>Category</Card.Title>
                    <Card.Text>
                      <span>T-Shirts</span>
                    </Card.Text>
                  </div>
                  <div className="card-row mt-3">
                    <div className="right-box mr-2">
                      <Card.Title>Sub-Category</Card.Title>
                      <Card.Text>
                        <span>Adults ±145g Super Cotton T-Shirts (501)</span>
                      </Card.Text>
                    </div>
                    <div className="element-group ctlg-qty-input-group">
                      <input
                        id={data.id}
                        type="number"
                        defaultValue={this.state.quantity}
                        min={1}
                        onChange={(e) =>
                          this.setState({
                            quantity: e.target.value,
                          })
                        }
                      />
                      <button
                        addonType="append"
                        className="action-button "
                        // onClick={() =>
                        //   this.handleAddToCart(one)
                        // }
                      >
                        <i className="icon-add"></i>
                      </button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
            <div className="col-lg-3 col-md-6 mt-4">
              <Card className="catalogue-card">
                <div
                  className="product-image"
                  // onClick={() => {
                  //  setIsOpen(true);
                  //  setLightBoxImage(one.image || "");
                  // }}
                  style={{
                    backgroundImage: `url(${demoProductImg})`,
                  }}
                ></div>

                <Card.Body>
                  <div className="header-text">
                    <Card.Title>
                      Adults ±145g Super Cotton T-Shirt - Royal
                    </Card.Title>
                  </div>
                  <div className="right-box">
                    <Card.Title>Category</Card.Title>
                    <Card.Text>
                      <span>T-Shirts</span>
                    </Card.Text>
                  </div>
                  <div className="card-row mt-3">
                    <div className="right-box mr-2">
                      <Card.Title>Sub-Category</Card.Title>
                      <Card.Text>
                        <span>Adults ±145g Super Cotton T-Shirts (501)</span>
                      </Card.Text>
                    </div>
                    <div className="element-group ctlg-qty-input-group">
                      <input
                        id={data.id}
                        type="number"
                        defaultValue={this.state.quantity}
                        min={1}
                        onChange={(e) =>
                          this.setState({
                            quantity: e.target.value,
                          })
                        }
                      />
                      <button
                        addonType="append"
                        className="action-button "
                        // onClick={() =>
                        //   this.handleAddToCart(one)
                        // }
                      >
                        <i className="icon-add"></i>
                      </button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div> */}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    productData: state.myCatalogue.catalogueDetail,
  };
};
export default connect(mapStateToProps, {
  CartApi,
  CatalogueDetailApi,
  resetCatalogueDetail,
})(SlugCatalogueProductDetail);
